import request from '@/utils/request';

//查询门店销售排行
export function getGlobalReport(param) {
  return request('/global-report/queryStoreSalesRanking', {
    method: 'GET',
    params: param,
  });
}

//查询电商销售排行
export function getQueryECSalesRanking(param) {
  return request('/global-report/queryECSalesRanking', {
    method: 'GET',
    params: param,
  });
}

//查询消费者性别分布接口
export function getQueryConsumerGenderDistribution(param) {
  return request('/global-report/queryConsumerGenderDistribution', {
    method: 'GET',
    params: param,
  });
}

//查询消费者性别分布接口
export function getQueryAgeReport(param) {
  return request('/global-report/queryAgeReport', {
    method: 'GET',
    params: param,
  });
}
//查询来源分布报表
export function getQueryChannelReport(param) {
  return request('/global-report/queryChannelReport', {
    method: 'GET',
    params: param,
  });
}

//查询消费者支付方式偏好接口
export function getQueryConsumerPayPreference(param) {
  return request('/global-report/queryConsumerPayPreference', {
    method: 'GET',
    params: param,
  });
}

//查询消费者渠道平台偏好接口
export function getQueryConsumerChannelPreference(param) {
  return request('/global-report/queryConsumerChannelPreference', {
    method: 'GET',
    params: param,
  });
}

//查询消费者款式偏好接口
export function getQueryConsumerStylePreference(param) {
  return request('/global-report/queryConsumerStylePreference', {
    method: 'GET',
    params: param,
  });
}

//查询粉丝累计关注人数
export function getQueryTotalConcerns(param) {
  return request('/global-report/queryTotalConcerns', {
    method: 'GET',
    params: param,
  });
}
//查询粉丝终端分布
export function getQueryFansTerminalDistribution(param) {
  return request('/global-report/queryFansTerminalDistribution', {
    method: 'GET',
    params: param,
  });
}
//查询粉丝性别分布
export function getQueryFansGenderDistribution(param) {
  return request('/global-report/queryFansGenderDistribution', {
    method: 'GET',
    params: param,
  });
}
//查询粉丝增长来源统计
export function getQueryFansGrowthSource(param) {
  return request('/global-report/queryFansGrowthSource', {
    method: 'GET',
    params: param,
  });
}
//查询近一个月关注量
export function getQueryFansAttentionRecentMonth(param) {
  return request('/global-report/queryFansAttentionRecentMonth', {
    method: 'GET',
    params: param,
  });
}
//查询会员总数
export function getQueryGlobalAllMember(param) {
  return request('/global-report/queryGlobalAllMember', {
    method: 'GET',
    params: param,
  });
}
//查询会员购买次数
export function getQueryMemberPurchasesTimes(param) {
  return request('/global-report/queryMemberPurchasesTimes', {
    method: 'GET',
    params: param,
  });
}
//查询会员等级分布
export function getQueryMemberLevelDistribution(param) {
  return request('/global-report/queryMemberLevelDistribution', {
    method: 'GET',
    params: param,
  });
}
//查询会员市场购买次数
export function getQueryMarketPurchasesTimes(param) {
  return request('/global-report/queryMarketPurchasesTimes', {
    method: 'GET',
    params: param,
  });
}
//查询市场会员活跃度占比
export function getQueryMarketMemberActivity(param) {
  return request('/global-report/queryMarketMemberActivity', {
    method: 'GET',
    params: param,
  });
}
//查询全国会员数和门店数及系列品种数
export function getQueryMiddle(param) {
  return request('/global-report/queryMiddle', {
    method: 'GET',
    params: param,
  });
}
//查询实时销售双数和销量总额
export function getQuerySalesTotal(param) {
  return request('/global-report/querySalesTotal', {
    method: 'GET',
    params: param,
  });
}
//查询Top10城市粉丝排名
export function getQueryCityFansTop(param) {
  return request('/global-report/queryFansProvinceDistribution', {
    method: 'GET',
    params: param,
  });
}
//查询Top10城市排名
export function getQueryCityTop(param) {
  return request('/global-report/queryCityTop', {
    method: 'GET',
    params: param,
  });
}
//门店鞋类销售排行
export function getQueryStoreStyleSalesRanking(param) {
  return request('/global-report/queryStoreStyleSalesRanking', {
    method: 'GET',
    params: param,
  });
}
//电商鞋类销售排行
export function getQueryECStyleSalesRanking(param) {
  return request('/global-report/queryECStyleSalesRanking', {
    method: 'GET',
    params: param,
  });
}
//最后欢迎商品
export function getQueryPopularProducts(param) {
  return request('/global-report/queryPopularProducts', {
    method: 'GET',
    params: param,
  });
}
//月销售趋势
export function getQueryMonthlySalesTrend(param) {
  return request('/global-report/queryMonthlySalesTrend', {
    method: 'GET',
    params: param,
  });
}
